module.exports = __webpack_public_path__ + "img/copy.a142f865.svg";